import { render, staticRenderFns } from "./protection.vue?vue&type=template&id=56d3ce4a"
import script from "./protection.vue?vue&type=script&lang=js"
export * from "./protection.vue?vue&type=script&lang=js"
import style0 from "./protection.vue?vue&type=style&index=0&id=56d3ce4a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports